


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter,Action } from "vuex-class";
import store from "@/store";
import getUrlParam from "@/common/utils/getUrlParam";

@Component
export default class UserAgreementModal extends Vue {
  @Prop()
  type!: string;
  @Getter('section') section!: any;
  @Getter("showFooter") showFooter!: boolean;
  @Action("changeShowFooter") changeShowFooter!: Function;
  @Action('changeSectionHasCheckUserAgreement') changeSectionHasCheckUserAgreement!: Function;

  toggleCheckUserAgreement(isCheck: boolean) {
    this.changeSectionHasCheckUserAgreement(isCheck)
  }

  handleViewUserAgreement(isOpen: boolean) {
    this.$emit("show");
  }
}
